import "../Styles/Business_set.css";
import { getData, saveData } from "../utils/store-data";
import Select, { components } from "react-select";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  GOOGLE_USER,
  LOGIN_BY,
  PHNO,
  PROFILE_LOGIN,
  USER_EMAIL,
  USER_ID,
} from "../utils/store-data-constants";
import {
  check_bussiness_name,
  create_agent,
  update_profile_photo,
  get_states,
  get_cities,
  check_email,
} from "../api/serverWrapper";
import { useEffect, useState } from "react";
import Agent from "../components/Agent";
import UserInfo from "../components/UserInfo";
import { useNavigate } from "react-router-dom";
import { customStylesbusiness } from "../utils/commonFunctions";
import {
  loginByEmail,
  loginByGoogle,
  loginByPhoneNo,
} from "../utils/Constants";
import { useMasterData } from "../context/MasterDataContext";
import BusinessSetupHeader from "./BusinessSetupHeader";

const cleanSelectStyles = {
  ...customStylesbusiness,

  option: (base) => ({
    ...base,
    backgroundColor: "white",
    color: "#333",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#f3f4f6",
    },
  }),

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#f1f5f9",
  }),
};

function Business_set_up() {
  const {
    religionMasterData,
    allCasteMasterData,
    communityMasterData,
    languageMasterData,
    allCountyMasterData,
  } = useMasterData();

  console.log(allCasteMasterData);

  const navigate = useNavigate();
  let [agentData, setAgentData] = useState(new Agent());
  let [userData, setUserData] = useState(new UserInfo());
  let [loginby, setLoginby] = useState(loginByPhoneNo);
  const [businessName, setBusinessName] = useState("");
  const [agentName, setAgentName] = useState("");
  let [Email, setEmail] = useState("");
  const [sameAsBusinessName, setSameAsBusinessName] = useState(false);
  const [experience, setExperience] = useState("");
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");

  const [religion, setReligion] = useState(religionMasterData || []);
  const [caste, setCaste] = useState(allCasteMasterData || []);
  const [communityList, setCommunity] = useState(communityMasterData || []);
  const [languages, setLanguages] = useState(languageMasterData || []);

  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState("");

  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);

  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  const [selectedReligion, setSelectedReligion] = useState([]);
  const [selectedCaste, setSelectedCaste] = useState([]);
  const [selectedCommunities, setSelectedCommunities] = useState([]);
  const [selectedLanuages, setSelectedLanguages] = useState([]);

  // Image Options BEGIN
  const defaultImage = require("../assests/images/profile.png");
  const [imageSource, setImageSource] = useState(defaultImage);
  let [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const loginMethod = Number(await getData(LOGIN_BY));
      if (loginMethod === loginByEmail) {
        let mail = await getData(USER_EMAIL);
        loginby = loginByEmail;
        setLoginby(loginby);
        Email = mail;
        setEmail(Email);
      }

      const googleUserStr = await getData(GOOGLE_USER);
      const googleUser = JSON.parse(googleUserStr);
      // console.log(googleUser);
      if (googleUser) {
        Email = googleUser.email;
        setEmail(Email);
        setAgentName(googleUser.name);
        setImageSource(googleUser.picture);
        loginby = loginByGoogle;
        setLoginby(loginby);
      }

      await fetchCountries();

      let phno = await getData(PHNO);
      console.log("phone Number ", phno);
      setPhoneNumber(phno);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCountries = async () => {
    try {
      // const res = await get_all_countries(); // replace with your endpoint
      const data = allCountyMasterData;

      if (data) {
        const formatted = data.map((c) => {
          const code = c.phonecode.startsWith("+")
            ? c.phonecode
            : `+${c.phonecode}`;

          return {
            value: c.isoCode,
            label: `${c.name} (${code})`,
            name: c.name,
            phoneCode: c.phonecode,
          };
        });

        console.log("formatted get_all_countries", formatted);
        setCountries(formatted);
      }
    } catch (err) {
      console.error("Error fetching countries", err);
    }
  };

  useEffect(() => {
    console.log("Selectd countryCode", countryCode);

    if (countryCode) {
      (async () => {
        try {
          console.log("Selectd inside countryCode", countryCode);
          const res = await get_states(countryCode);
          if (res.success) {
            const formattedStates = res.data.map((s) => ({
              value: s.isoCode,
              label: s.name,
              countryCode: s.countryCode,
            }));
            console.log("formattedStates ", formattedStates);

            setStates(formattedStates);
            setSelectedState(null); // reset state
            setCities([]); // reset cities
          }
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      })();
    }
  }, [countryCode]);

  // 2️⃣ When state changes, fetch cities
  useEffect(() => {
    if (countryCode && selectedState) {
      (async () => {
        try {
          const res = await get_cities(countryCode, selectedState.value);
          if (res.success) {
            const formattedCities = res.data.map((c) => ({
              value: c.name,
              label: c.name,
              stateCode: c.stateCode,
              countryCode: c.countryCode,
            }));
            setCities(formattedCities);
            setSelectedCity(null);
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      })();
    }
  }, [selectedState, countryCode]);

  const ReligionOptions = [
    { value: "all", label: "All Religions" },
    ...religion.map((item) => ({
      value: item.ReligionId,
      label: item.ReligionName,
    })),
  ];

  const filteredCastes =
    selectedReligion.includes("all") || selectedReligion.length === 0
      ? caste
      : caste.filter((c) => selectedReligion.includes(c.ReligionId));

  const casteOptions = [
    { value: "all", label: "All Castes" },
    ...filteredCastes.map((item) => ({
      value: item.CasteL2Id,
      label: item.CasteName,
    })),
  ];

  const communiteOptions = [
    { value: "all", label: "All Communities" },
    ...communityList.map((item) => ({
      value: item.CommunitiesId,
      label: item.CommunitiesName,
    })),
  ];

  const langOptions = [
    { value: "all", label: "All Languages" },
    ...languages.map((item) => ({
      value: item.LangId,
      label: item.LangDesc,
    })),
  ];

  useEffect(() => {
    if (selectedReligion.length === 1 && selectedReligion[0] === "all") {
      setSelectedCaste(["all"]);
    }
  }, [selectedReligion]);

  const checkBussinessName = async (businessName) => {
    try {
      const response = await check_bussiness_name({
        BusinessName: businessName,
      });
      return response;
    } catch (error) {
      console.log("Error checking business name:", error);
      return null;
    }
  };

  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
            style={{
              width: 16,
              height: 16,
              cursor: "pointer",
            }}
          />

          <span>{props.label}</span>
        </div>
      </components.Option>
    );
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const CreateAgent = async () => {
    if (isSubmitting) return; // ⛔ Prevent double click

    setIsSubmitting(true); // 🔄 Start spinner
    const userId = await getData(USER_ID);

    console.log(countryCode);

    console.log(userId);

    let code = countries.find((id) => id.value === countryCode)?.phoneCode;
    console.log(code);
    userData.UserId = userId ? Number(userId) : -1;
    userData.PhoneNumber = PhoneNumber;
    userData.FirstName = agentName;
    userData.CountyCode = code;
    userData.EMail = Email;
    agentData.BusinessName = businessName;
    agentData.BusinessAddress = address;
    agentData.BusinessDescription = description;
    agentData.BusinessExperience = experience;
    agentData.ReligionsServe = selectedReligion.includes("all")
      ? ["all"]
      : selectedReligion.map((item) => item.ReligionId);

    agentData.CastesServe = selectedCaste.includes("all")
      ? ["all"]
      : selectedCaste.map((x) => x.CasteL2Id);

    agentData.CommunitesServe = selectedCommunities.includes("all")
      ? ["all"]
      : selectedCommunities.map((x) => x.CommunitiesId);

    agentData.LanguagesServe = selectedLanuages.includes("all")
      ? ["all"]
      : selectedLanuages.map((x) => x.LangId);

    userData.LoginBy = loginby;
    // Basic validations

    if (!agentName.trim()) {
      alert("Please enter your Agent Name.");
      setIsSubmitting(false);
      return;
    }
    if (!businessName.trim()) {
      alert("Please enter your Business Name.");
      setIsSubmitting(false);
      return;
    }

    // 🔍 Check if business name already exists before proceeding
    const nameCheck = await checkBussinessName(businessName);
    console.log(nameCheck);

    if (nameCheck && !nameCheck.success) {
      alert("This Business Name already exists. Please use a different one.");
      setIsSubmitting(false);
      return;
    }

    if (!experience.trim()) {
      alert("Please enter Total years of business experience.");
      setIsSubmitting(false);
      return;
    }
    if (!countryCode) {
      alert("Please Select Country.");
      setIsSubmitting(false);
      return;
    }
    if (!selectedState) {
      alert("Please Select State.");
      setIsSubmitting(false);
      return;
    }
    if (!selectedCity) {
      alert("Please Select City.");
      setIsSubmitting(false);
      return;
    }

    if (!address.trim()) {
      alert("Please enter your Business Address.");
      setIsSubmitting(false);
      return;
    }
    // if (!description.trim()) {
    //   alert("Please enter your Business Description.");
    //   setIsSubmitting(false);
    //   return;
    // }
    if (loginby === loginByPhoneNo) {
      if (!PhoneNumber) {
        alert("Phone number is missing.");
        setIsSubmitting(false);
        return;
      }
    }

    if (loginby === loginByGoogle) {
      if (!Email) {
        alert("Email is missing.");
        setIsSubmitting(false);
        return;
      }
    }

    if (selectedReligion.length <= 0) {
      alert("Select Religion to Serve.");
      setIsSubmitting(false);
      return;
    }
    if (selectedCaste.length <= 0) {
      alert("Select Caste to Serve.");
      setIsSubmitting(false);
      return;
    }
    if (selectedCommunities.length <= 0) {
      alert("Select Communities to Serve.");
      setIsSubmitting(false);
      return;
    }
    if (selectedLanuages.length <= 0) {
      alert("Select Languages to Serve.");
      setIsSubmitting(false);
      return;
    }


     if (loginby === loginByPhoneNo && Email && Email.trim()) {
      const emailCheck = await check_email(Email);
      if (!emailCheck.success) {
        alert(emailCheck.message || "Email already exists");
        setIsSubmitting(false);
        return;
      }
    }

    agentData.address.CountryId = countryCode;
    agentData.address.StateId = selectedState.value;
    agentData.address.CityId = selectedCity.value;

    delete agentData.address.AddressDetails;
    delete agentData.address.ResidenceId;
    delete agentData.address.CitizenshipId;
    delete agentData.address.Ethinicity;

    // Cleanup user data
    Object.keys(userData).forEach((key) => {
      if (!userData[key]) {
        delete userData[key];
      }
    });

    delete userData.UserLanguage;
    agentData.userInfo = userData;

    console.log(agentData);
    // setIsSubmitting(false);
    // return;
    try {
      const resp = await create_agent(agentData);
      console.log(resp);

      if (resp.code === 200) {
        await saveData(USER_ID, resp.data.User.UserId);
        await saveData(AGENT_LOGIN, true);
        await saveData(CLIENT_LOGIN, false);
        await saveData(PROFILE_LOGIN, false);
        if (selectedImage) {
          await doUpdateProfileImage(resp.data.User.UserId, selectedImage);
        }

        localStorage.removeItem(GOOGLE_USER);
        navigate("/dashboard");
      } else {
        alert(`${resp.message}`);
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong while creating agent.");
    } finally {
      setIsSubmitting(false); // ✅ Stop spinner (always)
    }
  };

  const handleImageSelection = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileObj = {
      uri: file,
      fileName: file.name,
    };

    // Preview the image
    setImageSource(URL.createObjectURL(file));

    // Upload the image
    selectedImage = file;
    setSelectedImage(selectedImage);
  };

  const doUpdateProfileImage = async (id, selectedFile) => {
    if (!id) {
      alert("User ID not found.");
      return;
    }

    try {
      const response = await update_profile_photo(id, selectedFile);
      console.log("Image Upload Success: ", response);
      if (response.status === 200) {
        console.log("Image Upload Success: ", response);
        // alert("Profile image uploaded successfully.");
      } else {
        alert("Profile photo upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Image Upload error: ", error);
      alert("Error uploading image.");
    }
  };

  return (
    <div>
      {/* <div class="Business_setup">
        <img src={require("../assests/images/employee_sign_up-logo.png")} />
        <h2>Agent Sign up | Business setup</h2>
      </div> */}

      <BusinessSetupHeader name={"Agent Sign up | Business setup"} />
      <div className="Business_background_color">
        <div class="Business-container">
          <h2> Business overview</h2>

          <div class="field">
            <label>Business Name</label>
            <input
              type="text"
              placeholder="Enter Business Name"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
            />
          </div>

          <div class="field">
            <label>Your Agent Name</label>
            <input
              type="text"
              placeholder="Enter Your Name"
              value={agentName}
              onChange={(e) => setAgentName(e.target.value)}
            />
          </div>
          <div class="field">
            <label>Total Business Experience (in years)</label>
            <input
              type="number"
              placeholder="e.g. 5"
              value={experience}
              onChange={(e) => setExperience(e.target.value)}
              min="0"
            />
          </div>
          {loginby === loginByPhoneNo && (
            <div class="field">
              <label>Enter Email (optional)</label>
              <input
                type="email"
                placeholder="email"
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          )}

          <div className="field">
            <label>Select Country</label>

            <div style={{ height: 40 }}>
              <Select
                options={countries}
                placeholder="Select Country"
                value={countries.find((c) => c.value === countryCode) || null}
                onChange={(option) => setCountryCode(option.value)}
                isSearchable
                styles={customStylesbusiness}
              />
            </div>
          </div>

          <div className="field">
            <label>Select State</label>

            <Select
              options={states}
              placeholder="Select State"
              value={selectedState}
              onChange={(option) => setSelectedState(option)}
              isDisabled={!countryCode}
              isSearchable
              styles={customStylesbusiness}
            />
          </div>
          <div className="field">
            <label>Select City</label>

            <Select
              options={cities}
              placeholder="Select City"
              value={selectedCity}
              onChange={(option) => setSelectedCity(option)}
              isDisabled={!selectedState}
              isSearchable
              styles={customStylesbusiness}
            />
          </div>
          <div class="field">
            <label>Business Address</label>

            <textarea
              placeholder=" Example -Shop No 4, Panchayat Bhawan, Alwar Road, Gurgaon, Gurgaon"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              rows={4} // you can adjust the number of rows as needed
            />
          </div>
          <div class="field">
            <label>Business introduction (Optional) </label>

            <textarea
              type="text"
              placeholder="Example- Pioneering connections since 1995, our matrimony agency was founded in the heart of Delhi to serve the unique needs of the Hindu Brahmin community. "
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={6}
            />
          </div>
        </div>
        <div class="Business-container mt-4">
          <h2 className="mt-2"> Business Details</h2>

          <div className="field">
            <label>Religions you serve</label>

            <Select
              options={ReligionOptions}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              styles={cleanSelectStyles}
              placeholder="Select Religions"
              value={
                selectedReligion.includes("all")
                  ? [{ value: "all", label: "All Religions" }]
                  : ReligionOptions.filter((o) =>
                      selectedReligion.includes(o.value),
                    )
              }
              onChange={(opts) => {
                if (!opts?.length) return setSelectedReligion([]);

                const values = opts.map((o) => o.value);

                if (values.includes("all") && !selectedReligion.includes("all"))
                  return setSelectedReligion(["all"]);

                if (selectedReligion.includes("all"))
                  return setSelectedReligion(values.filter((v) => v !== "all"));

                setSelectedReligion(values);
              }}
            />
          </div>

          <div className="field">
            <label>Castes you serve</label>

            <Select
              options={casteOptions}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              styles={cleanSelectStyles}
              placeholder="Select Castes"
              value={
                selectedCaste.includes("all")
                  ? [{ value: "all", label: "All Castes" }]
                  : casteOptions.filter((o) => selectedCaste.includes(o.value))
              }
              onChange={(opts) => {
                if (!opts?.length) return setSelectedCaste([]);

                const values = opts.map((o) => o.value);

                if (values.includes("all") && !selectedCaste.includes("all"))
                  return setSelectedCaste(["all"]);

                if (selectedCaste.includes("all"))
                  return setSelectedCaste(values.filter((v) => v !== "all"));

                setSelectedCaste(values);
              }}
            />
          </div>

          <div className="business_setup_add "></div>

          <div className="field">
            <label>Communities you serve</label>
            <Select
              options={communiteOptions}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              styles={cleanSelectStyles}
              placeholder="Select Communities"
              value={
                selectedCommunities.includes("all")
                  ? [{ value: "all", label: "All Communities" }]
                  : communiteOptions.filter((o) =>
                      selectedCommunities.includes(o.value),
                    )
              }
              onChange={(opts) => {
                if (!opts?.length) return setSelectedCommunities([]);

                const values = opts.map((o) => o.value);

                if (
                  values.includes("all") &&
                  !selectedCommunities.includes("all")
                )
                  return setSelectedCommunities(["all"]);

                if (selectedCommunities.includes("all"))
                  return setSelectedCommunities(
                    values.filter((v) => v !== "all"),
                  );

                setSelectedCommunities(values);
              }}
            />
          </div>

          <div className="field">
            <label>Languages you serve</label>
            <Select
              options={langOptions}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              placeholder="Select Languages"
              styles={cleanSelectStyles}
              value={
                selectedLanuages.includes("all")
                  ? [{ value: "all", label: "All Languages" }]
                  : langOptions.filter((o) =>
                      selectedLanuages.includes(o.value),
                    )
              }
              onChange={(opts) => {
                if (!opts?.length) return setSelectedLanguages([]);

                const values = opts.map((o) => o.value);

                if (values.includes("all") && !selectedLanuages.includes("all"))
                  return setSelectedLanguages(["all"]);

                if (selectedLanuages.includes("all"))
                  return setSelectedLanguages(
                    values.filter((v) => v !== "all"),
                  );

                setSelectedLanguages(values);
              }}
            />
          </div>
        </div>
        <div className="profile-image">
          <h2 className="ps-3">Profile photo</h2>
          <p className="my-2">optional</p>
          <div className="Business_symbol">
            <label htmlFor="imageUpload" className="upload-label">
              <img
                src={imageSource}
                alt="Profile Preview"
                className="preview-image"
              />

              <div className="plus-icon-for-agent">
                <span style={{ color: "#B35381", fontSize: 30 }}> +</span>
              </div>
            </label>

            <input
              id="imageUpload"
              type="file"
              accept="image/*"
              onChange={handleImageSelection}
              className="hidden-input"
            />
          </div>
        </div>

        <div className="footer-reg">
          <div
            onClick={!isSubmitting ? CreateAgent : undefined}
            style={{
              pointerEvents: isSubmitting ? "none" : "auto",
              opacity: isSubmitting ? 0.6 : 1,
              cursor: isSubmitting ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <h3 style={{ margin: 0 }}>
              {isSubmitting ? "Submitting" : "Finish Registration ›"}
            </h3>

            {isSubmitting && <span className="spinner" />}
          </div>
        </div>

        <div className="business_footer_line"></div>
      </div>
    </div>
  );
}

export default Business_set_up;
